import { some } from 'lodash';

function addressIsUnchanged(address = {}) {
  return !some(address, { dirty: true });
}

export default addressIsUnchanged;
